import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { CompanySummary, HttpResponse } from "@/types";

export function useGetCompaniesSummary(
  options?: Partial<UseQueryOptions<CompanySummary[]>>,
) {
  return useQuery({
    ...options,
    queryKey: ["companies-summary"],
    queryFn: async () => {
      const path = "companies/summary";
      const res = await guacHttpClient.get<
        CompanySummary[],
        HttpResponse<CompanySummary[]>
      >(path);
      return res.data;
    },
  });
}
